"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var dealerblock_best_offer_history_service_1 = require("../../shared/services/dealerblock-best-offer-history.service");
var DealerblockViewBestOfferHistoryComponent = (function () {
    function DealerblockViewBestOfferHistoryComponent(dealerblockBestOfferHistoryService) {
        this.dealerblockBestOfferHistoryService = dealerblockBestOfferHistoryService;
    }
    DealerblockViewBestOfferHistoryComponent.prototype.ngOnInit = function () {
    };
    DealerblockViewBestOfferHistoryComponent.prototype.showBestOfferHistory = function () {
        if (this.bestOfferCount > 0) {
            this.dealerblockBestOfferHistoryService.showBestOfferHistory(this.nwVehicleId);
        }
    };
    return DealerblockViewBestOfferHistoryComponent;
}());
DealerblockViewBestOfferHistoryComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'nw-dealerblock-view-best-offer-history',
                template: "<span data-a8n=\"db-view-bestoffer-history\">\n    <a href=\"javascript:void(0)\" (click)=\"showBestOfferHistory()\"\n       [ngClass]=\"{'best-offer-history-disabled': bestOfferCount === 0, 'best-offer-history': bestOfferCount > 0 }\">\n        {{'dealerBlockLayout.bestOfferHistoryModal.header' | translate }}\n        <span data-a8n=\"db-bids-view-bestoffer-history\" *ngIf=\"bestOfferCount\">({{ bestOfferCount }})</span>\n    </a>\n</span>\n",
                styles: [".best-offer-history-disabled {   text-decoration: underline;   opacity: 0.5;   pointer-events: none; } .best-offer-history{   color: #0288D1;   text-decoration: underline;   //font-size: 12px;   font-weight: 500;   line-height: 20px; }"]
            },] },
];
/** @nocollapse */
DealerblockViewBestOfferHistoryComponent.ctorParameters = function () { return [
    { type: dealerblock_best_offer_history_service_1.DealerblockBestOfferHistoryService, },
]; };
DealerblockViewBestOfferHistoryComponent.propDecorators = {
    'bestOfferCount': [{ type: core_1.Input },],
    'nwVehicleId': [{ type: core_1.Input },],
};
exports.DealerblockViewBestOfferHistoryComponent = DealerblockViewBestOfferHistoryComponent;
//# sourceMappingURL=dealerblock-view-best-offer-history.component.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nw/dealerblock-bid-ui/components/dealerblock-view-best-offer-history/dealerblock-view-best-offer-history.component.js
// module id = GA7P
// module chunks = 0